import routerOptions0 from "/Users/david/clawd/localauthority/node_modules/.pnpm/nuxt@3.17.4_@libsql+client@0.15.5_@parcel+watcher@2.5.1_@types+node@22.15.29_better-sqlite3@1_kq2ohbwrs5kljyn4mydaobrkbu/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}